<div class="schedule-toggle">
    <span>
        {{'ci.common.generateThisReportOnSchedule' | translate}}
    </span>
    <uni-toggle [ngModel]="value" (ngModelChange)="toggle($event)"></uni-toggle>
</div>
